import React, { useState } from "react";
import { Link } from "react-router-dom";
import CircleLoading from "../shared/CircleLoading";

const EpisodeItem = ({ ep, user, course }) => {
  const [loading, setLoading] = useState(false);

  return (
    <Link
      to={
        course.buy === false ||
        ep.lock === 0 ||
        (user?.user?.developer === 1 && course.for_rank === 1)
          ? `/ep/${ep.id}`
          : "#"
      }
      className="w-full rounded-xl overflow-hidden group flex flex-col gap-3 bg-[#222]"
    >
      <div className="relative">
        <div className="w-full h-full absolute opacity-0 group-hover:opacity-100 p-4 bg-black bg-opacity-50 rounded-xl transition-all duration-300 flex justify-end items-end">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-7 h-7 fill-gray-400"
          >
            <path
              fill-rule="evenodd"
              d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
              clip-rule="evenodd"
            />
          </svg>
        </div>

        {!loading && ep.image ? (
          <div className="w-full bg-gray-800 rounded-xl flex justify-center items-center h-[176px]">
            <CircleLoading />
          </div>
        ) : (
          !ep.image && (
            <div className="w-full bg-gray-800 rounded-xl h-[176px] flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 stroke-gray-300"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                />
              </svg>
            </div>
          )
        )}

        {ep.image && (
          <img
            src={`https://api.myunibest.ir/${ep.image}`}
            className={`w-full rounded-xl object-cover ${!loading && "hidden"}`}
            onLoad={() => setLoading(true)}
            alt={ep.name}
          />
        )}

        {/* {ep.image ? (
          
        ) : (
          <div className="w-full bg-gray-800 rounded-xl h-[176px]"></div>
        )} */}

        {ep.subtitles.map((sub) => (
          <div className="absolute text-gray-300 py-1 px-2 bg-black bg-opacity-50 bottom-4 right-4 text-xs rounded-lg">
            زیرنویس {sub.language}
          </div>
        ))}
      </div>

      <div className="w-full flex flex-col text-gray-200 gap-2 px-3 pb-3">
        <h3 className="text-lg h-14">{ep.name}</h3>

        {ep.description ? (
          <div
            dangerouslySetInnerHTML={{ __html: ep.description }}
            className="text-xs text-gray-400 line-clamp-2 h-8"
          ></div>
        ) : (
          <p className="text-xs text-gray-400 line-clamp-2 h-8">
            توضیحات برای این قسمت ثبت نشده !
          </p>
        )}

        {course.buy === false ||
        ep.lock === 0 ||
        (user?.user?.developer === 1 && course.for_rank === 1) ? (
          <div className="flex justify-center items-center text-green-600 gap-1 mt-2 rounded-lg text-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-4 h-4"
            >
              <path
                fill-rule="evenodd"
                d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z"
                clip-rule="evenodd"
              />
            </svg>

            <span>مشاهده</span>
          </div>
        ) : (
          ep.lock === 1 && (
            <div className="flex justify-center items-center text-red-600 gap-1 mt-2 rounded-lg text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-4 h-4"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
                  clip-rule="evenodd"
                />
              </svg>

              <span>برای مشاهده دوره را خریداری کنید</span>
            </div>
          )
        )}
      </div>
    </Link>
  );
};

export default EpisodeItem;
